import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicLogsIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <path d="M20.57 24.78H5.43a1.69 1.69 0 01-1.68-1.69V2.91h5a1.69 1.69 0 011.69-1.69h5a1.69 1.69 0 011.69 1.69h5v20.18a1.69 1.69 0 01-1.56 1.69zM5.43 6.27v16.82h15.14V6.27zm1.68 13.46v-1.68h11.78v1.68zm0-5.05h11.78v1.68H7.11zm0-3.36h11.78V13H7.11z"/>
    </g>
  ]
  getViewBox = () => '0 0 26 26'
}
